<template>
	<div class="personal">
		<div class="topbagdiv">
			<div class="logodiv">
				<img src="../assets/images/logo.png" />
			</div>
			<div class="titlediv">
				<div class="usertitle">个人中心</div>
				<div class="selectbtn">
					<a href="javascript:void(0);" @click="inusermodule" class="userbox">
						用户信息
						<img src="../assets/images/usersjx.png"/>
						<div class="userboxdivss">
							<div class="bbbbor" v-if="userList!=null">
								<p>学号:{{userList.userAuth.identifier}}</p>
								<p>姓名:{{userList.name}}</p>
								<p>院系:{{userList.collegeName}}</p>
								<p>专业:{{userList.majorName}}</p>
								<p>班级:{{userList.className2}}</p>
								<p>安全问题:{{userList.questionName}}</p>
							</div>
						</div>
					</a>
					<a href="javascript:void(0);" @click="inchangepassword">修改密码</a>
					<a href="javascript:void(0);" @click="isshowbg = true">调查问卷</a>
				</div>
			</div>
			<div class="backdiv">
				<back></back>
			</div>
		</div>
		<div class="context">
			<!-- <usermodule v-if="type==''||type=='usermodule'" :type="type"></usermodule>
			<changepassword v-if="type=='changepassword'" :userall="userList"></changepassword> -->
			<router-view></router-view>
		</div>
		
		<div class="mypopup" v-if="isshowbg">
			
			<div class="box" v-if="showlist!=null">
				<a href="javascript:void(0);" @click="isshowbg=false"><img class="close"
						src="../assets/images/tcclose.png" /></a>
				<div class="wjdcbox">
					<div class="wjtitle">问卷调查</div>
					<div class="wjbox">
						<div class="types">客观题（请根据您的体验进行勾选打分）</div>
						<div class="boxitem" v-for="(item,index) in checkList">
							<div class="boxitemtext">{{item.text}}</div>
							<div class="check" v-for="item2 in item.list"><input v-model="ajaxdata[index].answer" type="radio"
									:name="'radio'+ (index+1)" :value="item2" />{{item2}}
							</div>
						</div>
						<div class="types">简答题</div>
						<div class="boxitem">
							<div class="boxitemtext">18.您认为本实验平台还有哪些地方可以改进优化？</div>
							<div>
								<div contenteditable="true" class="textarea" ref="textarea1"></div>
							</div>
						</div>
						<div class="boxitem">
							<div class="boxitemtext">19.您认为本课程对您最有帮助的地方有哪些？</div>
							<div>
								<div contenteditable="true" class="textarea" ref="textarea2"></div>
							</div>
						</div>
						<div class="boxitem">
							<div class="boxitemtext">20.您对本课程教学方面还有什么意见和建议？</div>
							<div>
								<div contenteditable="true" class="textarea" ref="textarea3"></div>
							</div>
						</div>
					</div>
					<div class="message" ref="message"></div>
					<div class="btnview">
						<button class="btnbtn" @click="submit">提交答卷</button>
					</div>
				</div>
			</div>
		</div>
		<popup ref="popup" :types="popuptype" :message="popupmessage"></popup>
	</div>
</template>

<script>
	import back from '../components/backhome/back.vue'
	import popup from '../components/popups/popup.vue'
	import usermodule from '../components/usermodule/usermodule.vue'
	import changepassword from '../components/changepassword/changepassword.vue'

	import axios from 'axios'
	export default {
		name: 'Personal',
		components: {
			back,
			usermodule,
			changepassword,
			popup
		},
		created() {
			this.getuserList()
		},
		data() {
			return {
				popuptype: "",
				popupmessage: "",
				type: '',
				userList: null,
				showlist:{
					title: '123',
					content: '123'
				},
				isshowbg: false,
				ajaxdata: [{
					title: '1.本实验课程重点突出，在教学与实训中具有不可或缺的支撑作用？',
					answer: null
				}, {
					title: '2.您认为本实验课程规划科学合理，体现了“以学习者为中心”的教育理念？',
					answer: null
				}, {
					title: '3.本实验课程能与新技术相结合构建智能化的虚拟仿真场景和辅助学习工具？',
					answer: null
				}, {
					title: '4.本实验课程设计规范、交互形式灵活多样？',
					answer: null
				}, {
					title: '5.本实验课程教学策略先进、得当，教学环节衔接科学、合理？',
					answer: null
				}, {
					title: '6.本实验课程知识点明确、突出，与理论课程衔接科学、自然？',
					answer: null
				}, {
					title: '7.本实验课程可更加直观地展示孙思邈有关的知识、事迹和医学思想？',
					answer: null
				}, {
					title: '8.本实验课程能完成一个相对完整的实训课程？',
					answer: null
				}, {
					title: '9.本实验课程对您中医药文化素养、医德水平提高有较大帮助？',
					answer: null
				}, {
					title: '10.本实验课程操作简便、健康友好、趣味性良好？',
					answer: null
				}, {
					title: '11.用户操作软硬件设备容易实现，便于学生学习？',
					answer: null
				}, {
					title: '12.系统兼容性好，操作方便，启动、链接转换时间短，没有“死机”现象？',
					answer: null
				}, {
					title: '13.多媒体技术使用科学、合理，素材选择精准、优质，有利于提升学习效果？',
					answer: null
				}, {
					title: '14.仿真环境逼真，沉浸感强，仿真效果好，与实训场景深度匹配？',
					answer: null
				}, {
					title: '15.制作精细，交互性强，能吸引和激发学习兴趣？',
					answer: null
				}, {
					title: '16.界面布局合理，整体风格统一，空间感染力强？',
					answer: null
				}, {
					title: '17.界面布局合理，整体风格统一，空间感染力强？',
					answer: null
				}, {
					title: '18.您认为本实验平台还有哪些地方可以改进优化？',
					answer: null
				}, {
					title: '19.您认为本课程对您最有帮助的地方有哪些？',
					answer: null
				}, {
					title: '20.您对本课程教学方面还有什么意见和建议？',
					answer: null
				}],
				checkList: [{
					text: '1.本实验课程重点突出，在教学与实训中具有不可或缺的支撑作用？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '2.您认为本实验课程规划科学合理，体现了“以学习者为中心”的教育理念？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '3.本实验课程能与新技术相结合构建智能化的虚拟仿真场景和辅助学习工具？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '4.本实验课程设计规范、交互形式灵活多样？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '5.本实验课程教学策略先进、得当，教学环节衔接科学、合理？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '6.本实验课程知识点明确、突出，与理论课程衔接科学、自然？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '7.本实验课程可更加直观地展示孙思邈有关的知识、事迹和医学思想？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '8.本实验课程能完成一个相对完整的实训课程？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '9.本实验课程对您中医药文化素养、医德水平提高有较大帮助？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '10.本实验课程操作简便、健康友好、趣味性良好？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '11.用户操作软硬件设备容易实现，便于学生学习？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '12.系统兼容性好，操作方便，启动、链接转换时间短，没有“死机”现象？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '13.多媒体技术使用科学、合理，素材选择精准、优质，有利于提升学习效果？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '14.仿真环境逼真，沉浸感强，仿真效果好，与实训场景深度匹配？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '15.制作精细，交互性强，能吸引和激发学习兴趣？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '16.界面布局合理，整体风格统一，空间感染力强？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}, {
					text: '17.界面布局合理，整体风格统一，空间感染力强？',
					list: ['5分', '4分', '3分', '2分', '1分']
				}]
			}
		},
		methods: {
			inquestionnaire(){
				this.$router.push('/questionnaire')
			},
			inusermodule() {
				this.$router.push('/personal/usermodule')
			},
			inchangepassword() {
				this.$router.push('/personal/changepassword')
			},
			getuserList(){
				let token = this.$store.state.token //token
				let userid = this.$store.state.userid //id
				axios({
					url: this.$api.commonUrl + 'student/' + userid,
					method: 'GET',
					headers: {
						"Authorization": "Bearer " + token
					}
				}).then(res => {
					if (res.data.code == '200') {
						this.userList = res.data.data
					}
				}).catch(err => {
					console.log("login", err)
				})
			}
			,submit() {
				let isno = 0
				let noindex = '第'
				let token = this.$store.state.token //token
				let userid = this.$store.state.userid //id

				if (this.$refs.textarea1.innerText) {
					this.ajaxdata[17].answer = this.$refs.textarea1.innerText
					if (this.$refs.textarea2.innerText) {
						this.ajaxdata[18].answer = this.$refs.textarea2.innerText
						if (this.$refs.textarea3.innerText) {
							this.ajaxdata[19].answer = this.$refs.textarea3.innerText
						}
					}
				}


				this.ajaxdata.map((item, index) => {
					if (!item.answer) {
						isno += 1
						noindex += (index + 1) + '题,'
					}
				})
				if (isno === 0) {
					this.$refs.message.innerText = ""
					axios({
						url: this.$api.commonUrl + 'questionnaire/add',
						method: 'POST',
						data: {
							studentId: userid,
							answers: this.ajaxdata
						},
						headers: {
							"Authorization": "Bearer " + token
						}
					}).then(res => {
						if (res.data.code == '200') {
							this.popuptype = 'success'
							this.popupmessage = "感谢您宝贵的意见！"
							this.$refs.popup.popupshow()
						}else{
							this.popuptype = 'success'
							this.popupmessage = res.data.message
							this.$refs.popup.popupshow()
						}
						this.isshowbg = false
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$refs.message.innerText = noindex + "没有作答"
				}
			}
		}
	}
</script>

<style scoped>
	.wjtitle{
		height: 5rem;
		    text-align: center;
		    font-size: 2.2rem;
		    line-height: 5rem;
		    font-family: 'STXingkai';
		    border-bottom: 1px dashed #5f3519;
		    color: #5f3519;
		    margin: 1rem;
		    letter-spacing: 0.5rem;
	}
	.wjdcbox{
		position: absolute;
		    right: 2rem;
		    top: 2rem;
		    bottom: 2rem;
		    left: 2rem;
		    overflow-y: auto;
	}
	.personal {
		position: absolute;
		background: #f3ede3;
		width: 100%;
		height: 100%;
	}

	.personal .topbagdiv {
		background: url(../assets/images/usertopbag.png) no-repeat;
		background-size: 100% auto;
		height: 6rem;
		display: flex;
		z-index: 2;
		box-shadow: 0px 0px 10px #efdcc9;
	}

	.personal .logodiv,
	.personal .backdiv {
		width: 25rem;
		height: 6rem;
	}

	.personal .titlediv {
		width: calc(100% - 50rem);
		height: 6rem;
		position: relative;
	}

	.personal .logodiv img {
		width: 16rem;
		height: 4.03rem;
		margin: calc(1.97rem / 2);
	}
	.personal .titlediv{
		text-align: center;
		height: 6rem;
	}
	.personal .usertitle{
		background: url(../assets/images/usertitlebag.png) no-repeat;
		background-size: 100% 100%;
		width: 25rem;
		height: 4rem;
		line-height: 4.5rem;
		font-size: 2rem;
		font-family: 'STXingkai';
		color: #783d1a;
		position: absolute;
		margin: auto;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
	}
	.personal .back .backimg{
		right: 1rem;
		top: 1rem;
	}
	.personal .selectbtn{
		width: 16rem;
		height: 4rem;
		float: right;
		margin-top: 1rem;
		display: flex;
	}
	.personal .selectbtn a{
		line-height: 4rem;
		color: #783d1a;
		text-decoration: none;
		display: block;
		width: 50%;
		font-size: 1rem;
		position: relative;
	}
	.personal .selectbtn a img{
		padding-left: 0.2rem;
	}
	.personal .context{
		background: url(../assets/images/userbaglt.jpg) no-repeat;
		background-size: 100% auto;
		background-position: left top;
		position: absolute;
		top: 6rem;
		left: 0;
		right: 0;
		bottom: 0;
		overflow-y: auto;
		z-index: 100;
		padding-left: calc((100% - 80rem) / 2);
		padding-right: calc((100% - 80rem) / 2);
		width: 80rem;
	}
	
	.personal .userboxdivss{
		position: absolute;
		width: 15rem;
		height: auto;
		background: #FFFFFF;
		z-index: 999;
		display: none;
		top: 3.5rem;
	}
	.personal .userbox:hover .userboxdivss{
		display: block;
	}
	.personal .userboxdivss .bbbbor{
		border: 1px solid #783d1a;
		margin: 2px;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
	}
	.personal .userboxdivss .bbbbor p{
		line-height: 1.5rem;
		font-size: 0.9rem;
		text-align: left;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
	}
	
	.personal .wjdcbox::-webkit-scrollbar {
		width: 6px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}
	
	/*滚动条里面小方块*/
	.personal .wjdcbox::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #af805c;
	}
	
	/*滚动条里面轨道*/
	.personal .wjdcbox::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ede3db;
	}
	.personal .wjdcbox::-webkit-scrollbar {
		width: 6px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}
	
	/*滚动条里面小方块*/
	.personal .context::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #af805c;
	}
	
	/*滚动条里面轨道*/
	.personal .context::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ede3db;
	}
	.personal .mypopup {
		position: fixed;
		z-index: 101;
		background: rgba(0, 0, 0, 0.5);
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
	}
	
	.personal .mypopup .box {
		width: 55%;
		height: 80%;
		background: url(../assets/images/tcbag.png);
		background-size: 100% 100%;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		position: absolute;
	}
	
	.personal .mypopup .close {
		position: absolute;
		width: 3rem;
		height: 3rem;
		right: -3rem;
		top: -3rem;
	}
	
	.personal .homepopup::-webkit-scrollbar {
		width: 6px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}
	
	/*滚动条里面小方块*/
	.personal .homepopup::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #af805c;
	}
	
	/*滚动条里面轨道*/
	.personal .homepopup::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ede3db;
	}
	.personal .wjbox{
		margin: 1rem;
		color: #5f3519;
	}
	.personal .types{
		font-size: 1.142857rem;
		line-height: 2.142857rem;
		font-weight: bold;
	}
	.personal .boxitemtext{
		font-size: 1.142857rem;
		line-height: 2.142857rem;
	}
	.personal .check{
		font-size: 1rem;
		line-height: 2.142857rem;
	}
	.personal .check input{
		margin-right: 0.5rem;
	}
	.btnview {
		text-align: center;
		margin-top: 5rem;
		margin-bottom: 5rem;
	}
	
	.btnbtn {
		border: none;
		outline: none;
		background: #a73a29;
		color: #fffef4;
		font-size: 1.071428rem;
		width: 7rem;
		height: 3rem;
		text-align: center;
		line-height: calc(3rem - 6px);
	}
	
	.message {
		text-align: center;
		line-height: 2.142857rem;
		font-size: 1.142857rem;
		color: #a73a29;
	}
	.textarea{
		border:1px solid #e4e4e4;
		min-height: 3rem;
		background: #FFFFFF;
		padding: 1rem;
	}
</style>
